import Section from "@/components/ui/section";
import React from "react";
import Image from "next/image";
import cn from "classnames";
export default function States({
  map,
  title,
  className,
  mapClass = "lg:w-[500px] md:w-[400px] w-full lg:h-[500px] md:h-[400px] h-[300px]",
}) {
  return (
    <Section className={className}>
      <h2 className="text-blue text-center mb-6">{title}</h2>
      <div
        className={cn(
          mapClass,
          "shrink-0 group flex justify-center items-center relative overflow-hidden mx-auto"
        )}
      >
        <Image
          src={map}
          alt={"map image"}
          fill
          className="object-contain object-center"
          sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px"
        />
      </div>
    </Section>
  );
}
